import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Layout } from '../styles';
import { localStore } from 'helpers';
import { Redirect, Route } from 'react-router-dom';

const propTypes = {
  history: PropTypes.object,
  currentUser: PropTypes.object,
  children: PropTypes.node
};

class MainLayout extends React.Component {
  componentDidMount() {
    document.addEventListener(
      'invalid',
      (function() {
        return function(e) {
          //prevent the browser from showing default error hint
          e.preventDefault();
          e.target.classList.add('form-invalid');
        };
      })(),
      true
    );
  }

  render() {
    const { children } = this.props;
    return <Layout>{children}</Layout>;
  }
}

MainLayout.propTypes = propTypes;

// MainLayout.childContextTypes = {};

export default withRouter(MainLayout);



// WEBPACK FOOTER //
// ./src/modules/layout/components/MainLayout.js